module.exports = __webpack_public_path__ + "static/media/VGS_Desktop_01.a0c23c78.png";